// Single STD Datepicker range
let chFI = '';
let chTI = '';
let reservitBaseUrl = $('.chalet_calendar--link').attr('href');
let spanUnderBtnText = $('.over-btn').first().text();

let min_capacity = parseInt($( "#min_capacity" ).val());
let max_capacity = parseInt($( "#max_capacity" ).val());
let nbr_children = 0;
let nbr_adulte = min_capacity;

let globalDateChanged = false;
let globalDateInited = false;
let globalBeginDate = "";
let globalEndDate = "";

/*let disabledDays = (disabledDays) ? JSON.parse(disabledDays) : [];
let datepicker = $('#datepicker').datepicker({
  language: locale,
  format: 'dd/mm/yyyy',
  datesDisabled: disabledDays,
  SingleDatePicker: true,
  startDate: new Date(),
  dateRange: true,
});
$('#datepicker').on('changeDate', function () {
  $('#datepicker-hidden').val(
    $('#datepicker').datepicker('getFormattedDate')
  );
});*/

//- Std Chalet res btn
let resBtn = $('.mobile-calendar .chalet_single--calender-mob-btn');

var modal_calendar = $('.mobile-calendar .chalet_single--calender');

function resModalFunc() {

    if (resBtn) {
      if (window.innerWidth <= 808) {
        modal_calendar.addClass('as_modal').addClass('modal');
        modal_calendar.modal({
          inDuration: 300, // Transition in duration
          outDuration: 200, // Transition out duration
          startingTop: '4%', // Starting top style attribute
          endingTop: '20%', // Ending top style attribute
        });
        modal_calendar.modal('open');
      } else {
        modal_calendar.removeClass('as_modal').removeClass('modal').removeAttr('style');
        modal_calendar.trigger('destroy.owl.carousel');
      }
    }
  }
  
  resBtn.on('click', function () {
    resModalFunc();
  });
  $(window).on('resize', function () {
  
    if (window.innerWidth > 808) {
      modal_calendar.removeClass('as_modal').removeClass('modal').removeAttr('style');
      modal_calendar.trigger('destroy.owl.carousel');
    }
  
  });

let linkC = $('.chalet_calendar--link');
let textBestPrice = $('.over-btn');
let linkCTextAvaiable = linkC.attr('data-btn-text-avaiable');
let linkCTextUnavaiable = linkC.attr('data-btn-text-unavaiable');

 function nextRequestForDispo(i) {
    return moment().startOf('day').add(89 * i, 'day');
  }
  
  function refreshCalendar(calendar) {
    var allClasses = [];
  
    var allElements = document.querySelectorAll('.' + calendar + ' *');
  
    for (var i = 0; i < allElements.length; i++) {
      var classes;
      var titles = [];
      if (typeof allElements[i].dataset.title != "undefined") {
        classes = allElements[i].className.toString();
        titles += allElements[i].dataset.title.toString();
      }
      else {
        titles += '--';
      }
  
      if (typeof classes != "undefined") {
        if (classes.includes("available"))
          classes = "available";
        else
          classes = "disabled";
      }
  
      if (titles != "--")
        allClasses.push(classes + ',' + titles);
  
    }
  
    for (var j = 1; j < allClasses.length; j++) {
  
      if (j + 1 < allClasses.length) {
        //console.log("j-1 " + allClasses[j - 1], "j " + allClasses[j], "j+1 " + allClasses[j + 1]);
        //console.log("j-1 " + allClasses[j - 1].includes("disabled"), "j " + allClasses[j].includes("available"), "j+1 " + allClasses[j + 1].includes("disabled"));
        if (allClasses[j - 1].includes("disabled") && allClasses[j].includes("available") && allClasses[j + 1].includes("disabled")) {
          var cell = allClasses[j].split(",", 2);
          $('[data-title=' + cell[1] + ']').addClass('full-disable disabled');
        }
        else if (allClasses[j - 1].includes("disabled") && allClasses[j].includes("available")) {
          cell = allClasses[j].split(",", 2);
          $('[data-title=' + cell[1] + ']').addClass('end-date-disable')
        }
        else if (allClasses[j + 1].includes("disabled") && allClasses[j].includes("available")) {
          cell = allClasses[j].split(",", 2);
          $('[data-title=' + cell[1] + ']').addClass('start-date-disable');
        }
      }
    }
  }
  
  function disableCalendarLink() {
    $('.chalet_calendar--link').css({"opacity": "0.5", "pointer-events": "none", "cursor":"default"})
      .html(linkCTextUnavaiable+'<div class="lds-dual-ring"></div>');
  }
  
  function checkCapacity(chFI, chTI) {
    linkC.removeAttr('style').toggleClass('loading',false);
    
    var capacity = '40,';
    if(nbr_adulte) {
        if(nbr_adulte < min_capacity){
            $( '.all_nbr' ).addClass( "error" );
            disableCalendarLink();
        }
        else if( (nbr_adulte + nbr_children) > max_capacity){
            $( '.all_nbr' ).addClass( "error" );
            disableCalendarLink();
        }
        else if( nbr_adulte  > max_capacity){
            $( '.children_error' ).addClass( "error" );
            disableCalendarLink();
        }
        else{
            $( '.all_nbr' ).removeClass( "error" );
            if(chFI && chTI){
                for (var i = 1; i <nbr_adulte ; i++) {
                    capacity += '40,'
                }
                if(nbr_children){
                    for (var j = 0; j <nbr_children ; j++) {
                        capacity += '10,'
                    }
                }
                
                $('.chalet_calendar--link').removeAttr("style");
            }
            else{
                disableCalendarLink();
            }
        }
    }
    else{
        $( '.adult_nbr' ).addClass( "error" );
        disableCalendarLink();
    }
  }
 
  function updateLinkC() {
    
    var mewsRoomID = $(".chalet_single--calender").eq(0).attr("data-mews-room-id");

    let chFI, chTI, days, start, end;
    if (globalBeginDate && globalEndDate) {
        start = moment(globalBeginDate);
        end = moment(globalEndDate);
        chFI = start.format('DD/MM/YYYY').split("/");
        chTI = end.format('DD/MM/YYYY').split("/");
        days = end.diff(start, 'days');
    }
    
    if (!start || !end) {
      disableCalendarLink();
      linkC.unbind('click');
      $('.over-btn').text(spanUnderBtnText).removeAttr('style');
    } else if ((days < parseInt(minimum_nights))) {
        disableCalendarLink();
        linkC.toggleClass('loading',false).unbind('click');
        $('.over-btn').text(locale == 'fr' ? 'Vous devez sélectionner au moins ' + minimum_nights + ' nuitées consécutives.' : 'You must select at least ' + minimum_nights + ' consecutive nights.').css('color', '#dc2242');
    } else {
        if (globalDateInited && globalDateChanged) {
          globalDateChanged = false;
          disableCalendarLink();
          linkC.toggleClass('loading',true).unbind('click');

          $('.over-btn .best-price').remove();
          $('.over-btn .txt-available').remove();

          $.ajax({
            type: "POST",
            url: '/index.php?p=actions/acbr/reservation/check-availability',
            data: { from: start.format('DD/MM/YYYY'), to: end.format('DD/MM/YYYY'), roomId: mewsRoomID },
            dataType: 'json',
            success: function (data) {
              if (data && !data.isAvailable) {
                let textError = linkC.attr('data-error-text');
                console.log(textError);
                disableCalendarLink();
                linkC.toggleClass('loading',false).unbind('click');
                $('.over-btn').toggleClass('available',false).toggleClass('unavailable',true);
                $('.over-btn .txt-available').remove();
                $('.over-btn').prepend('<span class="txt-available">'+textError+'</span>').css('color', '#dc2242');
              } else {
                let textSuccess = linkC.attr('data-success-text');
                $('.over-btn').toggleClass('available',true).toggleClass('unavailable',false);
                $('.over-btn').removeAttr('style').prepend('<span class="txt-available">'+textSuccess+'</span>');
                checkCapacity(chFI, chTI);
              }
            },
            error:function(e) {
              console.error('error fetch avaiability', e);
            }
          });
          
          if (mewsRoomID) {
            $.ajax({
              type: "POST",
              url: '/index.php?p=actions/acbr/reservation/check-best-price',
              data: { from: start.format('DD/MM/YYYY'), to: end.format('DD/MM/YYYY'), roomId: mewsRoomID, pers: nbr_adulte, nbr_adulte: nbr_adulte, nbr_children: nbr_children },
              dataType: 'json',
              success: function (data) {
                let price = parseFloat(data.bestPrice);
                if (price) {
                  price = price.toFixed(2);
                  let textBefore = textBestPrice.attr('data-text-before');
                  $('.over-btn').append('<span class="best-price">'+ textBefore + ' ' + price + '$' +'</span>');
                }
              },
              error:function(e) {
                console.error('error fetch best price', e);
              }
            });
          }
        } else {
          checkCapacity(chFI, chTI);
        }
    }

    window.dispatchEvent(new Event("updateLinkC"));
    
  } // END - updateLinkC
  
  function buildCalenndar(start = start, end = end) {
    if ($('.reservation-range .daterangepicker').length) {

      $('.reservation-range .input-daterange').datepicker({
        maxViewMode: 0,
        // inputs: $('input.date-start, input.date-end'),
        format: 'yyyy-mm-dd',
        language: locale,
        multidate: false,
        startDate: new Date()
      }).on('changeDate', function (e) {
        let isDateFrom = $(e.target).closest('input').hasClass("date-start");   
  
        let beginDate = $(e.target).closest(".daterangepicker").find('.date-start').datepicker('getDate');
        let endDate = $(e.target).closest(".daterangepicker").find('.date-end').datepicker('getDate');
        // globalDateChanged = true;

        if (globalBeginDate != beginDate) {
          globalBeginDate = beginDate;
          globalDateChanged = true;
        }

        if (isDateFrom) {
          globalEndDate = null;
          
          $(e.target).datepicker('hide');
          
          let pickerEnd = $(e.target).closest(".daterangepicker").find(".date-end");
          pickerEnd.datepicker('setStartDate', e.date);
          pickerEnd.datepicker('setDate', null);

          if (window.innerWidth >= 808) {
            pickerEnd.datepicker('show');
          }
        } else if (globalEndDate != endDate) {
          globalEndDate = endDate;
          globalDateChanged = true;
        }

        if (!isDateFrom) {
          $(e.target).datepicker('hide');
        }

        if (globalDateChanged) {
          updateLinkC();
        }
      });

      setTimeout(function() { 
        var dateSearchFrom = window.sessionStorage.getItem('date_from');
        var dateSearchTo = window.sessionStorage.getItem('date_to');
        var persSearch = window.sessionStorage.getItem('pers');
        if (dateSearchFrom) { $('.date-start').datepicker('setDate', dateSearchFrom); }
        if (dateSearchTo) { $('.date-end').datepicker('setDate', dateSearchTo); }
        if (persSearch) { 
          $('input[name="adult_nbr"]').val(persSearch); 
          nbr_adulte =  parseInt(persSearch);
        }
        
        globalDateInited = true;
        updateLinkC();
      }, 150);

      updateLinkC();
    }
  }
  
  buildCalenndar();
  
  /*if ($(window).outerWidth() < 808) {
    refreshCalendar('mobile-calendar');
  }
  else {
    refreshCalendar('desktop-calendar');
  }
  $('.chalet_single--calender').on('click', '.next.available', function (e) {
    e.preventDefault();
  });
  
  function findActiveValues() {
    setTimeout(function () {
      if ($('.calendar-table td.in-range').length == 0) {
        linkC.css({
          'opacity': '0.5',
          'pointer-events': 'none',
          'cursor': 'default'
        }).unbind('click');
      }
      if ($(window).outerWidth() < 808) {
        refreshCalendar('mobile-calendar');
      }
      else {
        refreshCalendar('desktop-calendar');
      }
    }, 1);
  }*/
  
  $('.change_adult').on('input', function() {
      nbr_adulte =  parseInt($(this).val());
      updateLinkC();
  });
  
  $('.change_children').on('input', function() {
      nbr_children = parseInt($(this).val());
      updateLinkC();
  });

  
  setInterval(function(){

    // return false;

    var behaviour_class = "JS_SYNC_LINK_FIELD";

    $(".chalet_single--calender:not(."+behaviour_class+")").each(function(){
      
      var self = this;
      var $self = $(self);

      $self.addClass(behaviour_class);

      var mewsHotelID = "10859ef3-19d0-4c9e-b7a9-b1e6004fe149";
      var mewsRoomID = $self.attr("data-mews-room-id");

      var update = function() {

          var $link = $self.find("a.chalet_calendar--link");
          
          $link.attr(`href`, `https://app.mews.com/distributor/${mewsHotelID}?mewsStart=${moment(globalBeginDate).format('YYYY-MM-DD')}&mewsEnd=${moment(globalEndDate).format('YYYY-MM-DD')}&mewsRoom=${mewsRoomID}&mewsRoute=rates&mewsAdultCount=${nbr_adulte}&mewsChildCount=${nbr_children}`);
        
  
      };
  
      update();

      window.addEventListener("updateLinkC", update);
      
  
    });

  }, 2000);
  